import React, { memo } from 'react'
import { Grid } from '@material-ui/core'
import PropTypes from 'prop-types'
import PageMetaData from '@v4/utils/data/PageMetaData'
import { useContent } from './Content.hooks'
import CommonContent from '../../../../components/Content'

const Content = props => {
	const [
		{
			classes,
			mobileAlignment,
			contentClasses,
			image,
			text,
			textConfig,
			rounding,
			extraShortcuts,
			textEditable,
			textKey,
		},
		{ handleTextClick, handleImageClick, handleTextChange },
	] = useContent(props)

	return (
		<Grid className={classes.root} container justify="center">
			<CommonContent
				mobileAlignment={mobileAlignment}
				image={image}
				text={text}
				textConfig={textConfig}
				classes={contentClasses}
				rounding={rounding}
				onImageClick={handleImageClick}
				onTextClick={handleTextClick}
				extraShortcuts={extraShortcuts}
				textEditable={textEditable}
				onTextChange={handleTextChange}
				textKey={textKey}
			/>
		</Grid>
	)
}

Content.propTypes = {
	buttonLink: PropTypes.string,
	classes: PropTypes.shape({
		root: PropTypes.string,
		content: PropTypes.string,
		image: PropTypes.string,
	}),
	image: PropTypes.instanceOf(PageMetaData),
	onImageClick: PropTypes.func,
	onTextClick: PropTypes.func,
	text: PropTypes.string,
	textConfig: PropTypes.object,
	rounding: PropTypes.number,
	extraShortcuts: PropTypes.objectOf(PropTypes.string),
	textEditable: PropTypes.bool,
	onTextChange: PropTypes.func,
	textKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	mobileAlignment: PropTypes.instanceOf(PageMetaData),
}

Content.defaultProps = {
	buttonLink: null,
	classes: undefined,
}
export default memo(Content)
